module.exports = __webpack_public_path__ + "assets/loginIcon.png";


//////////////////
// WEBPACK FOOTER
// ./libs/images/loginIcon.png
// module id = 353
// module chunks = 0